<template>
  <div class="batch-query-container">
    <HomeHeader />
    <div class="w1200" id="main_content">
      <div class="batch-query-content">
        <el-tabs v-model="activeTab" class="batch-query-tabs">
          <el-tab-pane label="新增批量查询任务" name="create">
            <BatchQueryCreate />
          </el-tab-pane>
          <el-tab-pane label="导出批量查询结果" name="export">
            <BatchQueryExport />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import HomeHeader from '../components/HomeHeader.vue'
import BatchQueryCreate from '../components/BatchQueryCreate.vue'
import BatchQueryExport from '../components/BatchQueryExport.vue'

const activeTab = ref('export')
</script>

<style scoped>
.batch-query-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.batch-query-content {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.batch-query-tabs {
  margin-bottom: 20px;
}
</style>